<script>
    import {Line} from 'vue-chartjs'

    //const ctx = document.getElementById('line-chart').getContext("2d");

    export default {
        extends: Line,
        props: {
            chartDataFileCount: {
                type: Array | Object,
                required: false
            },
            chartDataHour: {
                type: Array | Object,
                required: false
            },
            chartLabels: {
                type: Array,
                required: true
            },
            pointsClicked: {
                type: Function,
                required: true
            }
        },
        data() {
            return {
                options: {
                    onClick:  (evt, item) => {
                        this.$emit("pointsClicked",evt,item[0]['_index']);
                    },
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 50,
                            bottom: 0
                        }
                    },
                    legend: {
                        display: false
                    },

                    scales: {
                        yAxes: [{
                            ticks: {
                                fontColor: "rgba(255,255,255,1)",
                                fontStyle: "bold",
                                beginAtZero: true,
                                maxTicksLimit: 5,
                                padding: 20,
                                display: false
                            },
                            gridLines: {
                                color: "rgba(255, 255, 255, 0.1)",
                            },
                        }],
                        xAxes: [{
                            gridLines: {
                                color: "rgba(255, 255, 255, 0.1)",
                            },
                            ticks: {
                                padding: 20,
                                fontColor: "rgba(255,255,255,1.5)",
                                fontStyle: "bold",
                                callback: function (dataLabel, index) {
                                    return index % 3 === 0 ? dataLabel : '';
                                }
                            }
                        }]
                    },
                    tooltips: {
                        backgroundColor: "rgba(0,0,0,0)",
                        bodyFontColor: '#ffffff',
                        bodyFontSize: 12,
                        displayColors: false,
                        bodySpacing: 10,
                        bodyFontStyle: 'bold',
                        xPadding: 15,
                        yPadding: 10,
                        mode: 'nearest',
                        yAlign: 'bottom',
                        xAlign: 'center',
                        position: 'nearest',

                        callbacks: {
                            labelTextColor: function (tooltipItem, chart) {
                                return '#ffffff';
                            },
                            title: function (tooltipItem, data) {
                                return '';
                            },
                            label: function (tooltipItems, data) {
                                if (tooltipItems.datasetIndex === 0) {
                                    return tooltipItems.yLabel + " " + "hours";
                                }
                                else {
                                    return tooltipItems.yLabel + " " + "files";

                                }

                            }

                        }
                    }
                },
                ctx: null,
                gradientLineGreen: null,
                gradientLinePurple: null,
                gradientVerticalGreen: null,
                gradientHorizontalGreenLeftToRight: null,
                gradientVerticalPurple: null,
                gradientHorizontalPurpleRightToLeft: null
            }
        },
        mounted() {
            this.ctx = this.$refs.canvas.getContext('2d');
            this.gradientLineGreen = this.ctx.createLinearGradient(0, 500, 0, 100);
            this.gradientLineGreen.addColorStop(0, 'rgb(6, 224, 112)');

            this.gradientLinePurple = this.ctx.createLinearGradient(0, 500, 0, 100);
            this.gradientLinePurple.addColorStop(0, 'rgb(154, 63, 200)');

            this.gradientVerticalGreen = this.ctx.createLinearGradient(0, 500, 0, 0);
            this.gradientVerticalGreen.addColorStop(0, "rgba(6, 224, 112,0.0)");
            this.gradientVerticalGreen.addColorStop(1, "rgba(6 ,224, 112,0.3)");

            this.gradientHorizontalGreenLeftToRight = this.ctx.createLinearGradient(0, 0, 1000, 0);
            this.gradientHorizontalGreenLeftToRight.addColorStop(0, "rgba(6, 224, 112,0.0)");
            this.gradientHorizontalGreenLeftToRight.addColorStop(1, "rgba(6 ,224, 112,0.5)");


            this.gradientVerticalPurple = this.ctx.createLinearGradient(0, 500, 0, 0);
            this.gradientVerticalPurple.addColorStop(0, "rgba(154, 63, 200,0.0)");
            this.gradientVerticalPurple.addColorStop(1, "rgba(154, 63, 200,0.3)");

            this.gradientHorizontalPurpleRightToLeft = this.ctx.createLinearGradient(1000, 0, 0, 0);
            this.gradientHorizontalPurpleRightToLeft.addColorStop(0, "rgba(136,18,163,0.0)");
            this.gradientHorizontalPurpleRightToLeft.addColorStop(1, "rgba(136,18,163,0.5)");

            this.pointBackgroundColor = this.ctx.createLinearGradient(0, 500, 0, 100);
            this.pointBackgroundColor.addColorStop(0, 'rgb(225, 225, 225)');
            this.renderChart({
                labels: this.chartLabels,
                datasets: [
                    {
                        label: "avgTimeRight",
                        borderColor: this.gradientLineGreen,
                        pointBorderColor: this.pointBackgroundColor,
                        pointBackgroundColor: this.pointBackgroundColor,
                        pointHoverBackgroundColor: this.pointBackgroundColor,
                        pointHoverBorderColor: this.gradientLineGreen,
                        pointRadius: 1,
                        pointHoverRadius: 5,
                        fill: true,
                        backgroundColor: this.gradientHorizontalGreenLeftToRight,
                        borderWidth: 1,
                        data: this.chartDataHour
                    },
                    {
                        label: "avgTimeTop",
                        borderColor: this.gradientLineGreen,
                        pointBorderColor: this.pointBackgroundColor,
                        pointBackgroundColor: this.pointBackgroundColor,
                        pointHoverBackgroundColor: this.pointBackgroundColor,
                        pointHoverBorderColor: this.pointBackgroundColor,
                        pointRadius: 1,
                        pointHoverRadius: 5,
                        fill: true,
                        backgroundColor: this.gradientVerticalGreen,
                        borderWidth: 1,
                        data: this.chartDataHour
                    },
                    {
                        label: "unvertictedFilesTop",
                        borderColor: this.gradientLinePurple,
                        pointBorderColor: this.pointBackgroundColor,
                        pointBackgroundColor: this.pointBackgroundColor,
                        pointHoverBackgroundColor: this.pointBackgroundColor,
                        pointHoverBorderColor: this.gradientLinePurple,
                        pointRadius: 1,
                        pointHoverRadius: 5,
                        fill: true,
                        backgroundColor: this.gradientVerticalPurple,
                        borderWidth: 1,
                        data: this.chartDataFileCount
                    },
                    {
                        label: "unvertictedFilesLeft",
                        borderColor: this.gradientLinePurple,
                        pointBorderColor: this.pointBackgroundColor,
                        pointBackgroundColor: this.pointBackgroundColor,
                        pointHoverBackgroundColor: this.pointBackgroundColor,
                        pointHoverBorderColor: this.gradientLinePurple,
                        pointRadius: 1,
                        pointHoverRadius: 5,
                        fill: true,
                        backgroundColor: this.gradientHorizontalPurpleRightToLeft,
                        borderWidth: 1,
                        data: this.chartDataFileCount
                    }
                ],

            }, this.options)
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/hour-zero-prevention-timeline/HourZeroTimeLine.vue